"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/** @jsx jsx */
var react_1 = require("@emotion/react");
var rc_dropdown_1 = __importDefault(require("rc-dropdown"));
var react_2 = __importDefault(require("react"));
var DropdownMenu_1 = __importDefault(require("./DropdownMenu"));
var styles_1 = require("./styles");
var DropdownComponent = function (_a) {
    var menu = _a.menu, children = _a.children, props = __rest(_a, ["menu", "children"]);
    return (react_1.jsx(react_2.default.Fragment, null,
        react_1.jsx(react_1.Global, { styles: styles_1.dropdownContainerStyles }),
        react_1.jsx(rc_dropdown_1.default, __assign({ trigger: ['click'], overlay: menu, animation: "slide-up", onOverlayClick: function (e) { return e.stopPropagation(); } }, props), children)));
};
DropdownComponent.Menu = DropdownMenu_1.default;
exports.default = DropdownComponent;
